import {
  imgproxySettings,
  mobileImgproxySettings,
  resolveLifestyleOptionsFromSKU as resolveOptionsFromSKU,
  stripMatteOrInfinitePrefix,
} from './shared.mjs'

export const frame = {
  id: 'frame',
  name: 'Frame',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    black: {
      pathTemplate: 'gs://sg360/251117/miras/mf_black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mf_black_{nnn}.png',
    },
    fblue: {
      pathTemplate: 'gs://sg360/251117/miras/mf_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mf_blue_{nnn}.png',
    },
    fchampagne: {
      pathTemplate: 'gs://sg360/251117/miras/mf_mist_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mf_mist_{nnn}.png',
    },
    mist: {
      pathTemplate: 'gs://sg360/251117/miras/mf_mist_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mf_mist_{nnn}.png',
    },
    grape: {
      pathTemplate: 'gs://sg360/251117/miras/mf_grape_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mf_grape_{nnn}.png',
    },
    tortoise: {
      pathTemplate: 'gs://sg360/251117/miras/mf_tortoise_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mf_tortoise_{nnn}.png',
    },
    glacierblue: {
      pathTemplate: 'gs://sg360/260311/mf_Iglacierblue--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260311/mf_Iglacierblue--{nnn}.png',
    },
    desertsand: {
      pathTemplate: 'gs://sg360/260311/mf_Idesertsand--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260311/mf_Idesertsand--{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/260311/mf_Iclear--{nnn}.png',
      staticPathTemplate: 'gs://sg360/260311/mf_Iclear--{nnn}.png',
    },
  },
}

export const logos = {
  id: 'logos',
  name: 'Logos',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    Bblack: {
      pathTemplate: 'gs://sg360/251117/miras/mi_black_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mi_black_{nnn}.png',
    },
    Bblue: {
      pathTemplate: 'gs://sg360/251117/miras/mi_blue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mi_blue_{nnn}.png',
    },
    Bgold: {
      pathTemplate: 'gs://sg360/251117/miras/mi_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mi_gold_{nnn}.png',
    },
    Bgunmetal: {
      pathTemplate: 'gs://sg360/251117/miras/mi_gunmetal_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mi_gunmetal_{nnn}.png',
    },
    Brosegold: {
      pathTemplate: 'gs://sg360/251117/miras/mi_rosegold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mi_rosegold_{nnn}.png',
    },
    Bsilver: {
      pathTemplate: 'gs://sg360/251117/miras/mi_silver_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mi_silver_{nnn}.png',
    },
    Bwhite: {
      pathTemplate: 'gs://sg360/260514/miras/mi_white_{nnn}.png',
      staticPathTemplate: 'gs://sg360/260514/miras/mi_white_{nnn}.png',
    },
    Bgrape: {
      pathTemplate: 'gs://sg360/251117/miras/mi_grape_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras/mi_grape_{nnn}.png',
    },
  },
}

export const lenses = {
  id: 'lens',
  name: 'Lenses',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    brown: {
      pathTemplate: 'gs://sg360/251117/miras-v2/mle_brown_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras-v2/mle_brown_{nnn}.png',
    },
    gold: {
      pathTemplate: 'gs://sg360/251117/miras-v2/mle_gold_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras-v2/mle_gold_{nnn}.png',
    },
    grape: {
      pathTemplate: 'gs://sg360/251117/miras-v2/mle_grape_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras-v2/mle_grape_{nnn}.png',
    },
    grn: {
      pathTemplate: 'gs://sg360/251117/miras-v2/mle_green_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras-v2/mle_green_{nnn}.png',
    },
    rose: {
      pathTemplate: 'gs://sg360/251117/miras-v2/mle_rose_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras-v2/mle_rose_{nnn}.png',
    },
    silverblue: {
      pathTemplate: 'gs://sg360/251117/miras-v2/mle_silverblue_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras-v2/mle_silverblue_{nnn}.png',
    },
    smoke: {
      pathTemplate: 'gs://sg360/251117/miras-v2/mle_smoke_{nnn}.png',
      staticPathTemplate: 'gs://sg360/251117/miras-v2/mle_smoke_{nnn}.png',
    },
    clear: {
      pathTemplate: 'gs://sg360/250128/Miras_PrescriptionLens_{nnn}.png',
      staticPathTemplate: 'gs://sg360/250128/Miras_PrescriptionLens_{nnn}.png',
    },
  },
}

export const engraving = {
  id: 'engraving',
  name: 'Engraving',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    eN: {
      pathTemplate: 'gs://sg360/251117/miras/mlg_N_{nnn}.png',
    },
    eP: {
      pathTemplate: 'gs://sg360/251117/miras/mlg_P_{nnn}.png',
    },
    e8: {
      pathTemplate: 'gs://sg360/251117/miras/mlg_8_{nnn}.png',
    },
    e8P: {
      pathTemplate: 'gs://sg360/251117/miras/mlg_8P_{nnn}.png',
    },
    none: {
      disabled: true,
    },
  },
}

export const background = {
  id: 'background',
  name: 'Background',
  imgproxySettings: ['insecure', 'resize:fill:1400', 'plain'],
  mobileImgproxySettings: ['insecure', 'resize:fill:800', 'plain'],
  isBackground: true,
  options: {
    default: {
      pathTemplate: 'gs://sg360/251117/miras/shadow_{nnn}.png',
    },
  },
}

export function resolveOptions(customisedProduct) {
  const engraving =
    {
      '4ko': 'eN',
      '4kop': 'eP',
      '8ko': 'e8',
      '8kop': 'e8P',
    }[customisedProduct.lensTech] || 'none'

  return {
    frame: stripMatteOrInfinitePrefix(customisedProduct.frameChoice?.skuWithoutPrefix),
    lens: customisedProduct.lensChoice.skuWithoutLensTech.split('_')?.slice(1)?.join('_'),
    logos: customisedProduct.iconChoice?.sku?.split('_')?.slice(1)?.join('_'),
    engraving,
  }
}

export default {
  supports360: false,
  layers: [background, frame, logos, lenses, engraving],
  resolveOptions,
  resolveOptionsFromSKU,
}
